export interface ImageDimensions {
  width?: number;
  height?: number;
}

export function getImageDimensionsFromUri(imageUri: string): ImageDimensions {
  const width = Number(imageUri.match(/w\d+/g)?.[0].substring(1));
  const height = Number(imageUri.match(/h\d+/g)?.[0].substring(1));
  return {
    width: Number.isNaN(width) ? undefined : width,
    height: Number.isNaN(height) ? undefined : height,
  };
}
